import { render, staticRenderFns } from "./CulinaryPanel.vue?vue&type=template&id=a65b260e&scoped=true&"
import script from "./CulinaryPanel.vue?vue&type=script&lang=js&"
export * from "./CulinaryPanel.vue?vue&type=script&lang=js&"
import style0 from "./CulinaryPanel.vue?vue&type=style&index=0&id=a65b260e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65b260e",
  null
  
)

export default component.exports